import echart from 'echarts';
import { config } from '@/views/home/chartJs/chartCommon';
import fa from 'element-ui/src/locale/lang/fa';
let colorList = [
  // getColor('#4BB1FF','#0E69BF'),
  // getColor('#5586D4','#22437C'),
  // getColor('#75CAA8','#4E9772'),
  // getColor('#40F1FC','#208DA2'),
  // getColor('#5E89AA','#ADDAFB'),
  // getColor('#F1E26D','#C9B04E'),
  '#00C5FA',
  '#0078FF',
  '#FCF5C2',
  '#58ECAC',
  '#FF8C60',
  '#A280FF',
  '#EE6566',
  '#FAC959',
  '#91CD74',
  '#3AA272',
  // '#AAE6FF',
];
export default function drawPie(data, color = colorList) {
  let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, xAxis } = config;
  let pieData = data;
  function getColor(c1, c2) {
    return {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color: c1, // 0% 处的颜色
        },
        {
          offset: 1,
          color: c2, // 100% 处的颜色
        },
      ],
    };
  }
  let pieOption = {
    // title: {
    //   show: false,
    //   text: '',
    //   left: 'center',
    // },
    width: '100%',

    color,
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return params.seriesName === 'bg'
          ? ''
          : `<span style="display:inline-block;width: 10px;height: 10px;border-radius: 50%;background: ${params.color};"></span> ${params.data.name}: ${params.percent}%`;
      },
    },
    // grid: {
    // },
    legend: {
      show: false,
    },
    series: [
      {
        name: 'bg',
        type: 'pie',
        width: '100%',
        radius: ['50%', '60%'],
        // radius: '55%',
        center: ['50%', '50%'],
        startAngle: 40,
        selectedMode: false,
        data: [0],
        itemStyle: {
          color: 'rgba(0,197,250,0.3)',
          emphasis: {
            disabled: true,
          },
        },
        // hover
        label: {
          normal: {
            position: 'inner',
            show: false,
          },
        },
        emphasis: {
          disabled: true,
          // scaleSize: 15,//放大效果
          itemStyle: {
            show: false,
            // borderColor: 'rgb(255,255,255)',
            // borderWidth: 3,
          },
        },
      },
      {
        name: 'bg',
        type: 'pie',
        width: '100%',
        radius: ['40%', '50%'],
        // radius: '55%',
        center: ['50%', '50%'],
        startAngle: 40,
        selectedMode: false,
        clockwise: false,
        data: [0],
        itemStyle: {
          color: 'rgba(0,197,250,0.1)',
          emphasis: {
            disabled: true,
          },
        },
        label: {
          normal: {
            position: 'inner',
            show: false,
          },
        },
        emphasis: {
          disabled: true,
          // scaleSize: 15,//放大效果
          itemStyle: {
            show: false,
            // borderColor: 'rgb(255,255,255)',
            // borderWidth: 3,
          },
        },
      },
      {
        name: '',
        type: 'pie',
        width: '100%',
        radius: ['60%', '80%'],
        // radius: '55%',
        center: ['50%', '50%'],
        startAngle: 40,
        clockwise: false,
        label: {
          normal: {
            position: 'inner',
            show: false,
          },
        },
        selectedMode: true,
        selectedOffset: 10,
        data: pieData,
        emphasis: {
          // scaleSize: 15,//放大效果
        },
      },
    ],
  };

  // app.currentIndex = -1;
  // let chartDom = document.getElementById(dom);
  // let myChart = echart.init(chartDom);
  // setInterval(() => {
  //   var dataLen = pieOption.series[0].data.length;
  //   // 取消之前高亮的图形
  //   myChart.dispatchAction({
  //     type: 'downplay',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });
  //   app.currentIndex = (app.currentIndex + 1) % dataLen;

  //   // 高亮当前图形
  //   myChart.dispatchAction({
  //     type: 'highlight',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });

  //   // 显示 tooltip
  //   myChart.dispatchAction({
  //     type: 'showTip',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });

  //   myChart.dispatchAction({
  //     type: 'legendScroll',
  //     scrollDataIndex: app.currentIndex,
  //     legendId: 'stock-model',
  //   });
  // }, 1000);

  return pieOption;
}
